export const tr = {
    'add-correction': 'Yeni düzenleme',
    'choose-all-retargeting-conditions': 'Tüm hedef kitle seçim koşulları',
    'demography-title': 'Kullanıcının cinsiyeti ve yaşı',
    'device-title': 'Cihaz türü',
    'flat-mass-rate-control': 'Düzenleme için ortak teklif',
    'inventory-title': 'Envanter türü',
    'mass-rate-control': 'Teklif %{control}',
    'no-items-message': 'Teklif düzenlemeleri belirtilmedi.',
    'retargeting-edit-link': 'Koşul ayarları',
    'retargeting-title': 'Hedef kitle seçme koşulları',
    'same-values-for-all-rate-control': 'Tüm koşullar için aynı değerleri belirtin',
    'smart-banners-title': 'Otomatik oluşturulan akıllı reklamlar için teklif ayarları',
    'traffic-jam-hint':
        'Düzenlemelerde Yandex.Haritalar verileri kullanılır. Açık hava reklamları için reklam yüzeyinin önündeki trafik durumu dikkate alınır.',
    'traffic-jam-title': 'Trafik durumuna göre düzenleme',
    'video-addition-title': 'Video eklentili reklamlar için teklif ayarları',
    'weather-title': 'Hava durumu düzenlemeleri'
};
